import React, { useImperativeHandle, useState, forwardRef, useEffect } from 'react';
import { Col, Form, Row, DatePicker, Card, Select } from 'antd';
import Input from '../../../../../ui/Input';
import TextArea from '../../../../../ui/TextArea';
import { Grid } from '@material-ui/core';
import PageContainer from '../../../../../CSIComponents/PageContainer';
import { getOTACodes } from '../../../../../../services/common';

const dateFormat = 'MM/DD/YYYY';
const { Option } = Select;
const { RangePicker } = DatePicker;
let chargeErrHandle = false;
const AMOUNT = 'Charge (Amount)'
const TaxAdd = forwardRef((props: any, TaxesAddRef: any) => {
  const [form] = Form.useForm();

  const [chargeName, setChargeName] = useState<any>(`Charge (null)`);
  useImperativeHandle(TaxesAddRef, () => ({ detailsForm: form, restoreErr: () => { chargeErrHandle = false; } }))
  const [fttData, setFttData] = useState([])
  const getFttData = async () => {
    let res = await getOTACodes('FTT', '')
    if (res && res.otacodes && res.otacodes.length != 0) {
      setFttData(res.otacodes)
    } else {
      setFttData([])
    }
  };
  const [curData, setCurData] = useState([])
  const getCurData = async () => {
    let res = await getOTACodes('CUR', '')
    if (res && res.otacodes && res.otacodes.length != 0) {
      setCurData(res.otacodes)
    } else {
      setCurData([])
    }
  };

  const [chgFreData, setChgFreData] = useState([])
  const getChgFreData = async () => {
    let res = await getOTACodes('CHG', 'ChargeFrequency')
    if (res && res.otacodes && res.otacodes.length != 0) {
      setChgFreData(res.otacodes)
    } else {
      setChgFreData([])
    }
  };
  const [chgUnitData, setChgUnitData] = useState([])
  const getChgUnitData = async () => {
    let res = await getOTACodes('CHG', 'ChargeUnit')
    if (res && res.otacodes && res.otacodes.length != 0) {
      setChgUnitData(res.otacodes)
    } else {
      setChgUnitData([])
    }
  };
  useEffect(() => {
    getCurData();
    getFttData();
    getChgFreData();
    getChgUnitData();
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])

  useEffect(() => {
    if (chargeErrHandle) {
      props.validateFieldsError();
    } else {
      chargeErrHandle = true;
    }
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [chargeName])

  return (<div>
    <Form
      layout="vertical"
      form={form}
      name="basic"
      style={{ padding: 0 }}
      onValuesChange={(changedFields, allFields) => {
        props.validateFieldsError();
      }}
    ><PageContainer>
        <Card style={{ marginTop: -15 }}>
          <Grid container spacing={0} className="containerSpacing py-0">
            <Grid item xs={12} className="p-0">
              <div>
                <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>Taxes</div>
              </div>
            </Grid>
            <Grid item xs={12} className="pb-0 px-0 my-0">

              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label="Policy Name"
                    name="name"
                    rules={[{max: 128, message: 'You have reached the max character length of 128' }]}
                  >
                    <Input maxLength={128} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Effective Date ~ Discontinue Date"
                    name="rating"
                  >
                    <RangePicker
                      format={dateFormat}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}></Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label="Tax Type"
                    name="taxtype"
                  >
                    <Select allowClear showSearch>
                      <Option value="Inclusive">Inclusive</Option>
                      <Option value="Exclusive">Exclusive</Option>
                      <Option value="Cumulative">Cumulative</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Type"
                    name="type"
                    rules={[{ required: true, message: 'This field is required' }]}
                  >
                    <Select allowClear showSearch>
                      {fttData.map((item: any) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Charge Type"
                    name="chargetype"
                    rules={[{ required: true, message: 'This field is required' }]}
                  >
                    <Select allowClear onChange={value => {
                      setChargeName(`Charge (${value})`);
                      form.setFieldsValue({ charge: '' });
                    }}>
                      <Option value="Amount">Amount</Option>
                      <Option value="Percent">Percent</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6} className="col-margin" >
                  <Form.Item name="charge" label={chargeName}
                    rules={[
                      { required: true, message: 'This field is required' },
                      { pattern: /^\d*(\.\d*)?$/, message: "This field should be a number." }
                    ]}>
                    <Input />
                  </Form.Item>
                </Col>
                <>
                  {
                    chargeName === AMOUNT && <>

                      <Col span={6} className="col-margin">
                        <Form.Item name="currency" label="Currency" rules={[
                          { required: true, message: 'This field is required' },
                        ]}>
                          <Select allowClear showSearch
                            optionFilterProp="children"
                            // @ts-expect-error
                            filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {curData.map((item: any) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                    </>
                  }
                </>
                <Col span={6}>
                  <Form.Item
                    label="Charge Frequency"
                    name="chargefrequency"
                    rules={[
                      { required: true, message: 'This field is required' }]}
                  >
                    <Select allowClear showSearch>
                      {chgFreData.map((item: any) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                    </Select>
                  </Form.Item>
                </Col>
                <>
                  {
                    chargeName === AMOUNT && <Col span={6}></Col>
                  }
                </>
                <Col span={6}>
                  <Form.Item
                    label="Charge Unit"
                    name="chargeunit"
                    rules={[
                      { required: true, message: 'This field is required' }]}
                  >
                    <Select allowClear showSearch>
                      {chgUnitData.map((item: any) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                    </Select>
                  </Form.Item>
                </Col>
                <>
                  {
                    chargeName !== AMOUNT && <Col span={6}></Col>
                  }
                </>
                <Col span={6}>
                  <Form.Item
                    label="Sequence"
                    name="sequence"
                    rules={[
                      { pattern: /^\d*$/, message: "This field should be a number." }
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={18}>
                  <Form.Item
                    label="Description"
                    name="description"
                    rules={[{ max: 300, message: 'You have reached the max character length of 300' }]}
                  >
                    <TextArea maxLength={300} rows={3} />
                  </Form.Item>
                </Col>
              </Row>
            </Grid>
          </Grid>
        </Card>
      </PageContainer>
    </Form>

  </div >)
})

export default TaxAdd;
